// skipcq: JS-W1028, JS-0128
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';

import { db } from '../../utils/firebase';

/**
 * When the brewery belongs to a group, surfaces the brand display name with a shortcut to Brewery groups admin.
 *
 * @param {{ breweryGroupId?: string }} root0
 */
function BreweryGroupBanner({ breweryGroupId }) {
  const normalizedGroupId =
    typeof breweryGroupId === 'string' ? breweryGroupId.trim() : '';
  const [groupDisplayTitle, setGroupDisplayTitle] = useState('');
  useEffect(() => {
    let isCanceledFlag = false;
    async function fetchGroupBannerLabel() {
      setGroupDisplayTitle('');
      if (!normalizedGroupId) {
        return;
      }
      try {
        const groupSnapshotResult = await getDoc(doc(db, 'breweryGroups', normalizedGroupId));
        const parsedGroupRecord = groupSnapshotResult.data() ?? {};
        const brandCandidate =
          typeof parsedGroupRecord.displayName === 'string'
            ? parsedGroupRecord.displayName.trim()
            : '';
        const bannerLabelConstructed =
          brandCandidate.length > 0 ? brandCandidate : normalizedGroupId;
        if (!isCanceledFlag) {
          setGroupDisplayTitle(bannerLabelConstructed);
        }
      } catch {
        if (!isCanceledFlag) {
          setGroupDisplayTitle(normalizedGroupId);
        }
      }
    }
    fetchGroupBannerLabel();
    return () => {
      isCanceledFlag = true;
    };
  }, [normalizedGroupId]);

  if (!normalizedGroupId) {
    return null;
  }

  return (
    <Box
      sx={{
        px: 2,
        pt: 1,
        pb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
      }}
    >
      <Typography variant="body2" color="text.secondary" component="div">
        Brewery group:{' '}
        <Typography component="span" variant="body2" fontWeight={600} color="text.primary">
          {groupDisplayTitle || '…'}
        </Typography>
        {' · '}
        <Link
          component={RouterLink}
          to="/brewery-groups"
          variant="body2"
          underline="hover"
        >
          Open brewery groups
        </Link>
      </Typography>
    </Box>
  );
}

export default BreweryGroupBanner;
